module.exports = __webpack_public_path__ + "static/media/check-feature.ea8ce2ad.svg";